import { styled } from "@mui/material/styles";
import { IconButton } from '@mui/material';
import { useColors } from "../../../Context/ColorsContext"

export const StyledTable = styled('table')(() => {
    return {
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
        fontSize: 14,
        border: `1px solid #ccc`,
        borderRadius: '10px',
        overflow: 'hidden',
    }
})

export const StyledTh = styled('th')(() => {
    const { colors } = useColors();
    return {
        position: 'sticky',
        top: 0,
        padding: '8px 6px',
        textAlign: 'left',
        fontWeight: 'bold',
        fontSize: '14px',
        color: colors.navbarColor,
        backgroundColor: colors.gray,
        borderBottom: `1px solid #ccc`,
        borderRight: `1px solid #ccc`,
        zIndex: 1,
        '&:last-child': {
            borderRight: 'none',
        },
        '&:first-of-type': {
            borderTopLeftRadius: '10px',
        },
        '&:last-of-type': {
            borderTopRightRadius: '10px',
        },
    }
})

export const StyledTd = styled('td')(() => {
    return {
        padding: '4px 6px',
        borderBottom: `1px solid #ccc`,
        borderRight: `1px solid #ccc`,
        verticalAlign: 'middle',
        '&:last-child': {
            borderRight: 'none',
        },
        'tr:last-child &': {
            borderBottom: 'none',
        },
        'tr:last-child &:first-of-type': {
            borderBottomLeftRadius: '10px',
        },
        'tr:last-child &:last-of-type': {
            borderBottomRightRadius: '10px',
        },
    }
})

export const RemoveIconButton = styled(IconButton)(() => {
    const { colors } = useColors();
    return {
        borderRadius: '10%',
        backgroundColor: colors.background,
        color: colors.buttonActionColor,
        padding: 2,
        "&:hover": {
            backgroundColor: colors.buttonActionColor,
            opacity: 0.8,
            color: colors.background
        }
    }
})
